# GraphQL query to get a slack message by id

#import "../fragments/open-lead-slack-message-fragment.graphql"

query GetOpenLeadSlackMessage($id: ID!) {
    openLeadSlackMessage(id: $id) {
        ...SlackMessageAutomation
    }
}
